import { useMemo } from 'react'
import TableItem from '@/components/Table'
import { TABLE_HEADERS_DEVOLUCOES_TAB } from '@/pages/Pedidos/constants'

const DetalhesImportacaoResumo: React.FC<{ detalhesImportacao: any }> = ({ detalhesImportacao }) => {
  const mapedProperties = useMemo(() => {
    return [{
      totalEmpresas: detalhesImportacao?.totalDeEmpresas || 0,
      totalUsuarios: detalhesImportacao?.totalDeTrabalhadores || 0,
      devolucoesComErro: detalhesImportacao?.itensComErro || 0,
    }]
  }, [detalhesImportacao])

  return (
    <div className='p-5'>
      <TableItem
        isActions={false}
        isRowClicable={false}
        data={mapedProperties || []}
        headers={TABLE_HEADERS_DEVOLUCOES_TAB}
        deleteAction={() => void 0}
        hasCustomActions={false}
        idKey='id'
        isIdle={false}
      />
    </div>
  )
}

export default DetalhesImportacaoResumo
